/** Warns before tab close when a debounced IndexedDB export is still pending. */
export function installLocalSqliteBeforeUnloadGuard(hasPendingPersist: () => boolean): () => void {
  const handler = (ev: BeforeUnloadEvent): void => {
    if (!hasPendingPersist()) return;
    ev.preventDefault();
  };
  globalThis.addEventListener('beforeunload', handler);
  return () => globalThis.removeEventListener('beforeunload', handler);
}
